module.exports = __webpack_public_path__ + "media/images/emblems/La_Brillaz-coat_of_arms-1abe4c91aa033538cd905b9264aef5b7.svg";